import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { DiamondBorder, SectionLabel } from "./AipanPattern";
import {
  EMINENT_GUESTS,
  VISITING_PROFESSORS,
} from "../mock";

export default function EminentGuests() {
  const [idx, setIdx] = useState(0);
  const [perView, setPerView] = useState(3);
  const [activeTab, setActiveTab] = useState("Eminent Guests");

  useEffect(() => {
    const updatePerView = () => {
      if (window.innerWidth < 768) {
        setPerView(1);
      } else if (window.innerWidth < 1024) {
        setPerView(2);
      } else {
        setPerView(3);
      }
    };

    updatePerView();

    window.addEventListener("resize", updatePerView);

    return () => {
      window.removeEventListener("resize", updatePerView);
    };
  }, []);

 const activeData =
  activeTab === "Eminent Guests"
    ? EMINENT_GUESTS
    : VISITING_PROFESSORS;

// const max = Math.max(0, activeData.length - perView);
// const perView = 4;
const max = Math.max(0, activeData.length - perView);

  useEffect(() => {
    setIdx((current) => Math.min(current, max));
  }, [max]);

  return (
    <section className="py-24 pb-2 bg-gradient-to-b from-[var(--cream)] to-[var(--paper)] relative overflow-hidden">

      <div className="absolute inset-0 opacity-[0.04] pointer-events-none aipan-rope" />

      <div className="max-w-7xl mx-auto px-6 relative">

        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">

          <div className="-translate-y-[60px]">
           <div className="flex items-center gap-3">

            <button
              onClick={() => {
                setActiveTab("Eminent Guests");
                setIdx(0);
              }}
              className="cursor-pointer"
            >
              <SectionLabel>Eminent Guests</SectionLabel>
            </button>

            <button
              onClick={() => {
                setActiveTab("Visiting Professor");
                setIdx(0);
              }}
              className="cursor-pointer"
            >
              <SectionLabel>Visiting Professor</SectionLabel>
            </button>

          </div>

            <h2 className=" mt-2 font-display text-[38px] lg:text-[48px] font-bold">
              Legends who walked our{" "}
              <span className="italic text-[var(--terracotta)]">
                corridors
              </span>.
            </h2>
          </div>

     
        </div>

        <DiamondBorder className="-mt-12" />

   
       {/* SLIDER */}
 <div className="relative mt-5 px-10 md:px-0">

      <div className="overflow-hidden font-gill text-justify">

        <div
          className="flex transition-transform duration-500"
          style={{
            transform: `translateX(-${idx * (100 / perView)}%)`,
          }}
        >

          {activeData.map((g, i) => (

          <div
              key={i}
              className="
                w-full
                md:w-1/2
                lg:w-1/4
                shrink-0
                px-2
              "
            >

              <article className="
                group
                rounded-3xl
                bg-white
                border border-[var(--cream-deep)]
                overflow-hidden
                card-lift
              ">

                <div className="
                  h-[250px]
                    w-full
                overflow-hidden
                bg-[var(--cream)]
                flex
                items-center
                justify-center
                ">
                  <img
                    src={g.img}
                    alt={g.name}
                  className="
                    h-full
                    w-full
                    object-cover
                    object-top
                    group-hover:scale-105
                    transition-transform
                    duration-700
                  "
                  />
                </div>

                <div className="p-2">

                  <div className="
                    text-[11px]
                    tracking-[0.2em]
                    uppercase
                    text-[var(--saffron)]
                    font-semibold
                  ">
                    Guest of Honour
                  </div>

                  <h3 className="
                    mt-2
                    font-display
                    font-bold
                    text-[19px]
                    leading-tight
                    text-[var(--ink)]
                  ">
                    {g.award}
                  </h3>

                  <h3 className="
                    mt-2
                    font-display
                    font-bold
                    text-[19px]
                    leading-tight
                    text-[var(--ink)]
                  ">
                    {g.name}
                  </h3>

                  <p className="
                    mt-2
                    text-[13px]
                    text-[var(--ink)]/65
                    leading-relaxed
                    whitespace-pre-line
                  ">
                    {g.role}
                  </p>

                </div>

              </article>

            </div>

          ))}

        </div>

      </div>


      {/* LEFT ARROW */}
     {/* LEFT ARROW */}
<button
  onClick={() => setIdx((prev) => Math.max(0, prev - 1))}
  disabled={idx === 0}
  aria-label="Previous guests"
  className="
    absolute
    left-2 md:left-[-20px] lg:left-[-60px]
    top-[55%]
    -translate-y-1/2
    h-10 w-10 md:h-11 md:w-11
    rounded-full
    bg-[#132395]
    border border-[var(--cream-deep)]
    shadow-md
    grid place-items-center
    hover:bg-[var(--terracotta)]
    transition-colors
    disabled:opacity-40
    disabled:cursor-not-allowed
    z-20
  "
>
  <ChevronLeft size={18} className="text-white" />
</button>


      {/* RIGHT ARROW */}
      {/* RIGHT ARROW */}
<button
  onClick={() => setIdx((prev) => Math.min(max, prev + 1))}
  disabled={idx >= max}
  aria-label="Next guests"
  className="
    absolute
    right-2 md:right-[-20px] lg:right-[-60px]
    top-[55%]
    -translate-y-1/2
    h-10 w-10 md:h-11 md:w-11
    rounded-full
    bg-[#132395]
    border border-[var(--cream-deep)]
    shadow-md
    grid place-items-center
    hover:bg-[var(--terracotta)]
    transition-colors
    disabled:opacity-40
    disabled:cursor-not-allowed
    z-20
  "
>
  <ChevronRight size={18} className="text-white" />
</button>

    </div>

      </div>
    </section>
  );
}

